import Err from '../../models/err';

export default function createInvalidPhoneNumberError(attrName, value) {
  return new Err({ code: Err.Code.INVALID, attr: attrName, detail: 'not a valid phone number' });
}
